import { render, staticRenderFns } from "./internationaldis.vue?vue&type=template&id=6229cebe"
import script from "./internationaldis.vue?vue&type=script&lang=js"
export * from "./internationaldis.vue?vue&type=script&lang=js"
import style0 from "./internationaldis.vue?vue&type=style&index=0&id=6229cebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports